import { Dispatch, SetStateAction } from "react";
import { Dayjs } from "dayjs";
import "dayjs/locale/th";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { STATUS_FILTER } from "./data";

interface ReprintRequestFilterProps {
  search: string;
  setSearch: Dispatch<SetStateAction<string>>;
  status: string;
  setStatus: Dispatch<SetStateAction<string>>;
  dateFrom: Dayjs | null;
  setDateFrom: Dispatch<SetStateAction<Dayjs | null>>;
  dateTo: Dayjs | null;
  setDateTo: Dispatch<SetStateAction<Dayjs | null>>;
}

interface FilterFieldProps {
  label: string;
  children: React.ReactNode;
}

const FilterField = ({ label, children }: FilterFieldProps) => (
  <Grid size={{ xs: 12, sm: 4 }}>
    <Grid container alignItems="center" spacing={1}>
      <Grid size={4}>
        <Typography variant="body2" noWrap>
          {label}
        </Typography>
      </Grid>
      <Grid size={8}>{children}</Grid>
    </Grid>
  </Grid>
);

export default function ReprintRequestFilter({
  search,
  setSearch,
  status,
  setStatus,
  dateFrom,
  setDateFrom,
  dateTo,
  setDateTo,
}: ReprintRequestFilterProps) {
  return (
    <>
      <Grid container spacing={2} mb={1}>
        {/* Only `status` reaches the backend. Search + date range are page-scoped
            (see the caption below and data.ts#filterRowsInPage). */}
        <FilterField label="สถานะ">
          <TextField
            select
            size="small"
            fullWidth
            value={status}
            onChange={(e) => setStatus(e.target.value)}
          >
            {STATUS_FILTER.map((item) => (
              <MenuItem key={item.value} value={item.value}>
                {item.label}
              </MenuItem>
            ))}
          </TextField>
        </FilterField>
        <FilterField label="ค้นหา">
          <TextField
            size="small"
            fullWidth
            placeholder="เลขที่บิล / ชื่อลูกค้า / ผู้ขอ"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </FilterField>
        <FilterField label="วันที่ขอ (เริ่ม)">
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="th">
            <DatePicker
              value={dateFrom}
              format="DD/MM/YYYY"
              onChange={(value) => setDateFrom(value)}
              slotProps={{
                textField: { size: "small", fullWidth: true },
                field: { clearable: true },
              }}
            />
          </LocalizationProvider>
        </FilterField>
        <FilterField label="วันที่ขอ (สิ้นสุด)">
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="th">
            <DatePicker
              value={dateTo}
              format="DD/MM/YYYY"
              minDate={dateFrom ?? undefined}
              onChange={(value) => setDateTo(value)}
              slotProps={{
                textField: { size: "small", fullWidth: true },
                field: { clearable: true },
              }}
            />
          </LocalizationProvider>
        </FilterField>
      </Grid>

      <Typography variant="caption" color="text.secondary">
        หมายเหตุ: "ค้นหา" และ "วันที่ขอ" กรองเฉพาะรายการในหน้านี้
        (ระบบยังไม่รองรับการค้นหาทั้งหมด) — "สถานะ" กรองทุกรายการ
      </Typography>
    </>
  );
}
